import i18n from '../i18n';

/**
 * Maps i18n language codes to proper locale codes for sorting
 */
const getLocaleForSorting = () => {
  const currentLang = i18n.language || 'en';
  // Map 'no' to 'nb-NO' for proper Norwegian character sorting (æ, ø, å)
  return currentLang === 'no' ? 'nb-NO' : currentLang;
};

/**
 * Simple locale-aware sort function that automatically uses current language
 * Properly handles Norwegian characters (æ, ø, å) when Norwegian is selected
 */
export const simpleSort = (a, b, prop = null) => {
  const aVal = prop ? (a[prop] || '') : (a || '');
  const bVal = prop ? (b[prop] || '') : (b || '');
  
  try {
    const locale = getLocaleForSorting();
    // Use more appropriate options for Norwegian collation
    const options = locale === 'nb-NO' ? {
      sensitivity: 'accent',  // Treat æ, ø, å as distinct characters
      numeric: true,          // Handle numbers properly
      caseFirst: 'lower'      // Lowercase first in Norwegian
    } : {
      sensitivity: 'base',
      numeric: true
    };
    
    return String(aVal).localeCompare(String(bVal), locale, options);
  } catch (error) {
    // Fallback to basic string comparison if locale is not supported
    console.warn('Locale sorting failed, falling back to basic comparison:', error);
    return String(aVal).localeCompare(String(bVal));
  }
};

export default simpleSort; 